import { SaveOutlined } from '@ant-design/icons';
import {
    Button, Form, Input, notification,
} from 'antd';
import { useState } from 'react';
import { useApiFetch } from '../../hooks/api/useApiFetch';

const AvitoChatNoteForm = ({ id, note }: { id: number; note: string | null; }) => {
    const api = useApiFetch();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values: any) => {
        setLoading(true);
        const response = await api.fetchData(`/avito-chats/${id}/note`, 'post', true, values);

        if (response.success) {
            notification.success({
                message: 'Заметка успешно сохранена',
            });
        } else {
            notification.error({
                message: response.message || 'Непредвиденная ошибка',
            });
        }

        setLoading(false);
    };

    return (
        <Form layout="vertical" onFinish={onFinish} initialValues={{ note }}>
            <Form.Item label="Заметка о беседе" name="note">
                <Input.TextArea />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading}>
                    Сохранить
                </Button>
            </Form.Item>
        </Form>
    );
};

export default AvitoChatNoteForm;
